import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TextState } from "../objects/textState";
import { ADD_CUSTOM_PICTURES } from "../../../picture/redux/actionTypes";
import { Picture } from "../../../picture/objects/picture";

const initialState: TextState = {
    editor_pictures: {},
    editor_id: ''
};

const setEditorIdReducer = (state: TextState, action: PayloadAction<string>): TextState => ({
    ...state, editor_id: action.payload
});

const addEditorPicturesExtraReducer = (state: TextState, action: PayloadAction<Picture[]>): TextState => ({
    ...state, editor_pictures: { ...state.editor_pictures, [state.editor_id]: action.payload }
});

const restoreEditorPicturesReducer = (state: TextState): TextState => ({
    ...state, ...initialState
});

export const text = createSlice({
    name: 'text',
    initialState,
    reducers: {
        setEditorId: setEditorIdReducer,
        restoreEditorPictures: restoreEditorPicturesReducer
    },
    extraReducers: {
        [ADD_CUSTOM_PICTURES]: addEditorPicturesExtraReducer,
    }
});

export const { setEditorId, restoreEditorPictures } = text.actions;